/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Servis_S4_Li_Incident_LabelInputs */

const tr_servis_s4_li_incident_label = /** @type {(inputs: Servis_S4_Li_Incident_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kritik olay yanıtı:`)
};

const en_servis_s4_li_incident_label = /** @type {(inputs: Servis_S4_Li_Incident_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Critical incident response:`)
};

const de_servis_s4_li_incident_label = /** @type {(inputs: Servis_S4_Li_Incident_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reaktion auf kritische Vorfälle:`)
};

const ru_servis_s4_li_incident_label = /** @type {(inputs: Servis_S4_Li_Incident_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Реакция на критические инциденты:`)
};

/**
* | output |
* | --- |
* | "Critical incident response:" |
*
* @param {Servis_S4_Li_Incident_LabelInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const servis_s4_li_incident_label = /** @type {((inputs?: Servis_S4_Li_Incident_LabelInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Servis_S4_Li_Incident_LabelInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_servis_s4_li_incident_label(inputs)
	if (locale === "de") return de_servis_s4_li_incident_label(inputs)
	if (locale === "ru") return ru_servis_s4_li_incident_label(inputs)
	return tr_servis_s4_li_incident_label(inputs)
});